<template>
  <!-- Topbar -->
  <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
    <!-- Sidebar Toggle (Topbar) -->
    <button id="sidebarToggleTop" class="btn btn-link rounded-circle mr-3" @click="$parent.toggled=!$parent.toggled">
      <i class="fa fa-bars"></i>
    </button>


    <!-- Topbar Navbar -->
    <div class="navbar-nav ml-auto">


      <!-- Notification -->
      <Notification />
      <!-- End Notification -->

      <div class="topbar-divider d-none d-sm-block"></div>

      <!-- Nav Item - User Information -->
      <div class="nav-item dropdown no-arrow">
        <a
          class="nav-link dropdown-toggle"
          href="#"
          id="userDropdown"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          @click="toggleDropdown"
        >
          <span class="mr-2 d-none d-lg-inline text-gray-600 small">{{ name }}</span>
          <img
            class="img-profile rounded-circle"
            src="https://source.unsplash.com/QAB-WJcbgJk/60x60"
          />
        </a>
        <!-- Dropdown - User Information -->
        <div
          class="dropdown-menu dropdown-menu-right shadow animated--grow-in"
          aria-labelledby="userDropdown"
          :class="{show: show}"
        >
          <a class="dropdown-item" href="#">
            <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
            Profile
          </a>
          <a class="dropdown-item" href="#">
            <i class="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
            Settings
          </a>
          <a class="dropdown-item" href="#">
            <i class="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
            Activity Log
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="#" @click="logout">
            <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
            Logout
          </a>
        </div>
      </div>
    </div>
  </nav>
  <!-- End of Topbar -->
</template>

<script>
import { mapGetters } from 'vuex'
import Notification from '@/components/utils/Notification'
export default {
  components: {
    Notification
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapGetters([
      'name', 'role'
    ])  },
  methods: {
    toggleDropdown() {
      this.show = !this.show
    },
    logout() {
      this.$store.dispatch('user/logout').then(() => {
        this.$router.push('/login')
      })
    }
  }
}
</script>

<style>
</style>
